<script lang="ts">
	//UI
	//Utils
	import { createEventDispatcher } from "svelte";
	import type { StoreUserMinDTO } from "@hitit/api";
	import moment from "moment";
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let user: StoreUserMinDTO;
	export let index = 0;
	export let borderBottom = false;
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function deleteHandler(index: number) {
		dispatch("deleteHandler", {
			index,
		});
	}
	//Do
	$: formatDate = moment(new Date(user.createdDate + "Z").toISOString()).format(
		"yyyy.MM.DD"
	);

</script>

<div class="row" class:borderBottom on:click>
	<div class="phone col">
		<img
			class="delete-icon"
			src="/img/icons/deleteIcon.png"
			alt={'delete'}
			on:click|stopPropagation={() => deleteHandler(index)} />
		<p class="text">{user.userIdentity}</p>
	</div>
	<div class="create col">
		<p class="text">{formatDate}</p>
		<span class="for-mobile">{$t('global.register')}</span>
	</div>
	<div class="current col">
		<span class="for-mobile">{$t('global.Now')}</span>
		<p class="text">{user.totalActiveReward}P</p>
	</div>
	<div class="accumulate col">
		<p class="text">{user.totalReward}P</p>
	</div>
	<div class="used col">
		<p class="text">{user.totalUsedReward}P</p>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.row {
		width: 100%;
		transition: 0.2s background-color;

		&.borderBottom {
			border-bottom: 1px solid #e6e7ec;
		}

		display: flex;
		flex-direction: column;
		padding: 10px 0px;
		box-sizing: border-box;
		gap: 10px;

		.phone {
			display: flex;
			align-items: center;
			flex-direction: row-reverse;
			justify-content: space-between;
			font-size: 1.25rem;
			font-weight: 500;
			color: #46474b;
			order: 1;

			img {
				width: 25px;
				cursor: pointer;
			}
		}

		.text {
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.current {
			font-weight: 500;
			color: #46474b;
			order: 2;
		}

		.create {
			font-size: 0.875rem;
			color: #6d6f76;
			order: 3;
		}

		.create,
		.current {
			display: flex;
			gap: 5px;
		}

		.accumulate,
		.used {
			display: none;
		}
	}

	@include DesktopSize {
		.for-mobile {
			display: none;
		}

		.row {
			display: flex;
			flex-direction: row;
			padding: 20px 0px;
			&:hover {
				cursor: pointer;
				background-color: #f0f0f4;
			}
			.col {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 20%;
				max-width: 20%;
				color: #46474b;
				font-size: 1.25rem;
			}

			.phone {
				font-size: 1.25rem;
				order: 1;
				flex-direction: row;
				justify-content: center;
				p {
					padding-left: 20px;
				}
			}

			.current {
				font-weight: 500;
				order: 3;
			}
			.accumulate {
				order: 4;
			}
			.used {
				order: 5;
			}

			.create {
				font-size: 1.25rem;
				color: #46474b;
				order: 2;
			}
			.col {
				display: flex;
				overflow: hidden;
			}
			.phone,
			.current {
				font-weight: 550;
			}
		}
	}

</style>
